import { Controller, useFormContext } from 'react-hook-form';

import { SectionColumn, ColumnsSectionContainer } from 'components/DetailsView/Section';
import { DetailFormSelect } from 'components/DetailsView';
import { OdooPartnerSelect } from 'components/OdooPartnerSelect';
import { OdooCompany, OdooPartnerKind } from 'data/__generated__';

import { ODOO_COMPANY_LABELS } from '../constants/labels';

export const OdooFields = ({ stacked = false }: { stacked?: boolean }) => {
    const { control } = useFormContext();

    return (
        <ColumnsSectionContainer numberOfColumns={stacked ? 1 : 2}>
            <SectionColumn>
                <DetailFormSelect<string | null>
                    label="Entité juridique acheteuse *"
                    sublabel="Société du bon de commande et du bon de livraison."
                    name="odooCompany"
                    options={[
                        { value: OdooCompany.Nseda, label: ODOO_COMPANY_LABELS[OdooCompany.Nseda] },
                        { value: OdooCompany.Neocorner, label: ODOO_COMPANY_LABELS[OdooCompany.Neocorner] },
                    ]}
                    required
                    dataTest="supplier-odooCompany"
                />
            </SectionColumn>
            <SectionColumn>
                <Controller
                    name="odooSupplierId"
                    control={control}
                    defaultValue={null}
                    rules={{ required: 'Associez le fournisseur à une société Odoo avant toute action.' }}
                    render={({ field, fieldState }) => (
                        <>
                            <OdooPartnerSelect
                                kind={OdooPartnerKind.Supplier}
                                label="Société Odoo *"
                                sublabel="Recherchez et sélectionnez le partenaire fournisseur Odoo."
                                value={field.value ?? null}
                                onChange={(option) => field.onChange(option?.value ?? null)}
                                isInvalid={!field.value}
                                dataTest="supplier-odooSupplierId"
                            />
                            {fieldState.error && (
                                <span role="alert" className="text-destructive">
                                    {fieldState.error.message}
                                </span>
                            )}
                        </>
                    )}
                />
            </SectionColumn>
        </ColumnsSectionContainer>
    );
};
